import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { HelmetProvider } from "react-helmet-async";
import { RouterProvider } from "react-router-dom";

import MockToggle from "./components/features/auth/MockToggle";
import { MockModeProvider } from "./contexts/MockModeContext";
import { QueryClientProvider } from "./providers";
import { AuthProvider } from "./providers/AuthProvider";
import { router } from "./router";
import { LazyErrorBoundary } from "./router/LazyErrorBoundary";

import "material-icons/iconfont/filled.css";
import "material-icons/iconfont/outlined.css";
import "react-datepicker/dist/react-datepicker.css";

export function App() {
  return (
    <HelmetProvider>
      <MockModeProvider>
        <QueryClientProvider>
          <AuthProvider>
            <LazyErrorBoundary>
              <RouterProvider router={router} />
            </LazyErrorBoundary>

            <MockToggle />

            <ReactQueryDevtools initialIsOpen={false} />
          </AuthProvider>
        </QueryClientProvider>
      </MockModeProvider>
    </HelmetProvider>
  );
}
